import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styles: []
})
export class AdministrationComponent implements OnInit {

  constructor(private jhiLanguageService: JhiLanguageService) {
    this.jhiLanguageService.setLocations(['home']);
  }

  ngOnInit(): void {
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/components/administration/administration.component.ts